export default __webpack_public_path__ + "static/media/ms.eb2b7bb6.png";